import Dialog from 'components/Dialog.jsx';
import MessageActions from 'groups/actions/MessageActions';
import MessageStore from 'groups/stores/MessageStore';
import GroupMessageList from 'groups/components/GroupMessageList.jsx';
import GroupStore from 'groups/stores/GroupStore';
import React, { Component } from 'react';

import styles from './styles/GroupMessageListModal.css';

export default class GroupMessageListModal extends Component {
  static propTypes = {
    groupCode: React.PropTypes.string.isRequired,
  };

  componentWillMount() {
    this.group = GroupStore.getGroupForCode(this.props.groupCode);
    const groupId = this.group.id;
    if (!MessageStore.isDoneLoadingForGroup(groupId)) {
      MessageActions.loadMessages(groupId);
    }
  }

  render() {
    return (
      <Dialog
        eventScreenName="GroupMessageListModal"
        {...this.props}
        className={styles.this}>
        <GroupMessageList group={this.group} className={styles.messages} />
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessageListModal.jsx